import type { PropsWithChildren } from 'react';

export const ColumnHeader = ({ children }: PropsWithChildren) => (
  <span className="text-s font-medium">{children}</span>
);
